/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-quill/~/lodash/_freeGlobal.js
 ** module id = 670
 ** module chunks = 0
 **/